// extracted by mini-css-extract-plugin
export default {"wrapper":"BottomNavigation_wrapper__HKoVy","slotWrapper":"BottomNavigation_slotWrapper__S6RR1","slot":"BottomNavigation_slot__hMzRX","link":"BottomNavigation_link__Ealrq"};